<button
  mat-icon-button
  class="lg:hidden"
  (click)="menuToggle.emit()"
  aria-label="Abrir/cerrar menú lateral"
>
  <mat-icon svgIcon="menu"></mat-icon>
</button>

<app-breadcrumb class="hidden lg:block" />

<span class="flex-auto"></span>

<app-global-search class="max-w-xs" />

<app-notification-bell />

<button
  mat-icon-button
  (click)="cycleTheme()"
  [matTooltip]="'Tema: ' + themeLabels[themeService.mode()] + ' (clic para cambiar)'"
  aria-label="Cambiar tema"
>
  <mat-icon [svgIcon]="themeIcons[themeService.mode()]"></mat-icon>
</button>

@if (tokenService.user(); as user) {
  <button
    class="ml-1 rounded-full p-0"
    [matMenuTriggerFor]="userMenu"
    [matTooltip]="user.fullName"
    aria-label="Menú de usuario"
  >
    <app-avatar [name]="user.fullName" size="sm" />
  </button>

  <mat-menu #userMenu="matMenu">
    <div class="px-4 py-2">
      <div class="font-medium text-primary">{{ user.fullName }}</div>
      <div class="text-small text-secondary">{{ user.email }}</div>
    </div>
    <button mat-menu-item routerLink="/account/profile">
      <mat-icon svgIcon="user"></mat-icon>
      <span>Mi perfil</span>
    </button>
    <button mat-menu-item routerLink="/account/sessions">
      <mat-icon svgIcon="smartphone"></mat-icon>
      <span>Mis sesiones</span>
    </button>
    <button mat-menu-item (click)="logout()">
      <mat-icon svgIcon="log-out"></mat-icon>
      <span>Cerrar sesión</span>
    </button>
  </mat-menu>
}
